import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { route } from "../../../../shim/jsbridge";

const ERROR_PROCESSING_STATE = 3;

const ExtractedFilesTableFileCount = ({
  isLoading,
  fileCount,
  cloud,
  sha1,
  sampleSourceId,
  state,
  relationship,
  onClick,
  href
}) => {
  let returnValue = <span>--</span>;
  if (isLoading && fileCount === undefined) {
    returnValue = <span className="u-blank-data" />;
  } else if (cloud && fileCount) {
    returnValue = <span>{fileCount}</span>;
  } else if (fileCount > 0 && sha1 && state !== ERROR_PROCESSING_STATE) {
    returnValue = (
      <Link
        to={
          href ||
          `${route("samples_details_main", {
            hash_value: sha1,
            source_id: sampleSourceId
          })}extracted-files/?path=/&r=${relationship}`
        }
        className="no-expand file-count grid-row-link overflow-ellipsis pointer-cursor"
        onClick={onClick}
      >
        {fileCount + 1}
      </Link>
    );
  } else if (sha1) {
    returnValue = <span>1</span>;
  } else if (fileCount) {
    returnValue = <span>{fileCount}</span>;
  }

  return returnValue;
};

ExtractedFilesTableFileCount.propTypes = {
  isLoading: PropTypes.bool,
  fileCount: PropTypes.number,
  cloud: PropTypes.bool,
  sha1: PropTypes.string,
  sampleSourceId: PropTypes.string,
  state: PropTypes.number,
  relationship: PropTypes.number,
  sourceId: PropTypes.number,
  onClick: PropTypes.func,
  href: PropTypes.string
};

export default ExtractedFilesTableFileCount;
